export default "__VITE_ASSET__VBTACESu__"